import { Controller } from "@hotwired/stimulus";

// « Ajouter un apprenant » (2026-10-15) : the group selector shows the classes of ONE group
// (« Francophone · Secondaire général »…) instead of 127 pills at once. Without this script
// every group stays visible and the form still works.
export default class extends Controller {
  static targets = ["select", "group"];

  connect() {
    this.element.classList.add("is-picking");
    this.show();
  }

  show() {
    const current = this.selectTarget.value;
    this.groupTargets.forEach((group) => {
      group.hidden = group.dataset.group !== current;
      // A class ticked in a group now hidden would still be posted, and still satisfy
      // `required`: it is unticked, so the parent picks one in the visible group.
      if (group.hidden) {
        group.querySelectorAll("input[type=radio]:checked").forEach((radio) => {
          radio.checked = false;
        });
      }
    });
  }
}
